import { dispatchUpdateReportEvent } from './dispatch';
import { ReporterSections } from '../common/Reporter/constants';
import { DeliveryMode } from '../common/constants';
import deliveryModeToPlayback from '../util/deliveryModeToPlayback';

export default function dispatchUpdatePlayback(dm?: DeliveryMode): void {
  const value = { playback: deliveryModeToPlayback(dm ?? DeliveryMode.NONE) };
  const section = ReporterSections.General;
  dispatchUpdateReportEvent({ value, section, override: true });
}
